import { IKnmLateChangedField } from '../interfaces/IKnmLateChangedField';

export const knmLateChangedFields: Record<string, IKnmLateChangedField> = {
  '/inspector/{id}/fullName': {
    name: 'ФИО должностного лица, уполномоченного на проведение проверки',
  },
  '/inspector/{id}/inspectorType/name': {
    name: 'Тип лица, уполномоченного на проведение КНМ',
  },
  '/inspector/{id}/position': {
    name: 'Должность лица, уполномоченного на проведение КНМ',
  },
  '/inspectors/{id}/fullName': {
    name: 'ФИО должностного лица, уполномоченного на проведение проверки',
  },
  '/inspectors/{id}/position': {
    name: 'Должность лица, уполномоченного на проведение КНМ',
  },
  '/inspectors/{id}/type/name': {
    name: 'Тип лица, уполномоченного на проведение КНМ',
  },
  '/inspectors/{id}/position/title': {
    name: 'Должность лица, участвующего в КНМ',
  },
  '/fullName': {
    name: 'Сведения о должностном лице, участвующего в КНМ',
  },
  '/objects/{id}/address': {
    name: 'Местоположение объекта проведения КНМ',
  },
  '/objects/{id}/manualAddress': {
    name: 'Адрес объекта проведения КНМ (нет в ФИАС)',
  },
  '/objects/{id}/region': {
    name: 'Субъект РФ объекта проведения КНМ (нет в ФИАС)',
  },
  '/objects/{id}/addressType/name': {
    name: 'Тип места проведения КНМ',
  },
  '/objects/{id}/objectType/name': {
    name: 'Тип объекта проведения КНМ',
  },
  '/objects/{id}/riskCategory/name': {
    name: 'Категория риска объекта проведения КНМ',
  },
  '/objects/{id}/objectType/title': {
    name: 'Тип объекта',
  },
  '/objects/{id}/objectKind/title': {
    name: 'Вид объекта',
  },
  '/objects/{id}/objectSubKind/title': {
    name: 'Подвид объекта',
  },
  '/objects/{id}/riskCategory/title': {
    name: 'Категория риска',
  },
  '/objects/{id}/dangerClass/title': {
    name: 'Класс опасности',
  },
  '/objects/{id}/name': {
    name: 'Наименование объекта',
  },
  '/objects/{id}/ervkNumber': {
    name: 'Номер объекта',
  },
  '/objects/{id}/geolocation': {
    name: 'Координаты объекта',
  },
  '/organization/{id}/act/numberAct': {
    name: 'Номер акта КНМ',
  },
  '/organization/{id}/act/creationActDateTime': {
    name: 'Дата и время составления акта КНМ',
  },
  '/organization/{id}/act/signActDateTime': {
    name: 'Дата и время подписания акта КНМ',
  },
  '/organization/{id}/act/holdingDateTime': {
    name: 'Дата и время начала проведения КНМ',
  },
  '/organization/{id}/act/durationDays': {
    name: 'Срок проведения (дней)',
  },
  '/organization/{id}/act/durationHours': {
    name: 'Срок проведения (часов)',
  },
  '/organization/{id}/act/fioSigner': {
    name: 'ФИО подписавшего акт',
  },
  '/organization/{id}/act/signers/{id}/fioSigner': {
    name: 'ФИО подписавшего акт',
  },
  '/organization/{id}/act/isViolationResolvedNote': {
    name: 'Комментарий факта устранения выявленного нарушения',
  },
  '/organization/{id}/act/isActWasRead': {
    name: 'Сведения об ознакомлении контролируемых лиц с результатами контрольного (надзорного) мероприятия',
  },
  '/organization/{id}/act/acquaintanceLack': {
    name: 'Сведения о причинах не ознакомления',
  },
  '/organization/{id}/act/acquaintanceLackNoInfoComment': {
    name: 'Комментарий у причины неознакомления',
  },
  '/organization/{id}/act/fioReader': {
    name: 'Лицо, ознакомленное с результатами контрольного (надзорного) мероприятия',
  },
  '/organization/{id}/act/refuserFio': {
    name: 'Кто отказал',
  },
  '/organization/{id}/act/refuserTitle': {
    name: 'Кто отказал (должность)',
  },
  '/organization/{id}/act/titleReader': {
    name: 'Должность лица, ознакомленного с результатами контрольного (надзорного) мероприятия',
  },
  '/organization/{id}/act/noteInvalidate': {
    name: 'Сведения о признании недействительными результатов КНМ',
  },
  '/organization/{id}/act/document/attachments/{id}/fileName': {
    name: 'Файл акта',
  },
  '/organization/{id}/act/titleSigner/title': {
    name: 'Должность/доверенность лица, подписавшего акт',
  },
  '/organization/{id}/act/typeAct/name': {
    name: 'Вид акта',
  },
  '/organization/{id}/act/canceledReason/name': {
    name: 'Причина невозможности проведения КНМ',
  },
  '/organization/{id}/act/isViolations': {
    name: 'Наличие нарушенного обязательного требования',
  },
  '/organization/{id}/act/events/{id}/event/title': {
    name: 'Акт - Перечень действий, осуществляемых в рамках КНМ',
  },
  '/organization/{id}/act/events/{id}/event/inspectors/{id}/fullName': {
    name: 'Акт - Должностное лицо, осуществившее действие',
  },
  '/organization/{id}/act/events/{id}/event/startDate': {
    name: 'Акт - Дата начала действий, осуществляемых в рамках КНМ',
  },
  '/organization/{id}/act/events/{id}/event/stopDate': {
    name: 'Акт - Дата окончания действий, осуществляемых в рамках КНМ',
  },
  '/organization/act/numberAct': {
    name: 'Номер акта КНМ, СР',
  },
  '/organization/act/creationActDateTime': {
    name: 'Дата и время составления акта КНМ, СР',
  },
  '/organization/act/signActDateTime': {
    name: 'Дата и время подписания акта КНМ, СР',
  },
  '/organization/act/document/attachments/{id}/fileName': {
    name: 'Файл акта',
  },
  '/organization/{id}/resultDecisions/{id}/document/attachments/{id}/fileName': {
    name: 'Файл решения',
  },
  '/organization/{id}/resultDecisions/{id}/kindDecision/name': {
    name: 'Вид решения',
  },
  '/organization/{id}/resultDecisions/{id}/dateDecision': {
    name: 'Дата решения',
  },
  '/organization/{id}/resultDecisions/{id}/numberDecision': {
    name: 'Номер решения',
  },
  '/organization/{id}/resultDecisions/{id}/fioSigner': {
    name: 'ФИО подписавшего решение',
  },
  '/organization/{id}/resultDecisions/{id}/signers/{id}/fioSigner': {
    name: 'Подписанты решения',
  },
  '/organization/{id}/resultDecisions/{id}/titleSigner/title': {
    name: 'Должность лица, подписавшего решение',
  },
  '/organization/{id}/resultDecisions/{id}/inspectors/{id}/fullName': {
    name: 'ФИО лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
  },
  '/organization/{id}/resultDecisions/{id}/inspectors/{id}/position/title': {
    name: 'Должность лица контрольного (надзорного) органа, участвовавшего в контрольных (надзорных) мероприятиях',
  },
  '/organization/{id}/resultDecisions/{id}/isProsecution': {
    name: 'Сведения о привлечении к ответственности по результатам контрольных (надзорных) мероприятий',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/responsibilityType/name': {
    name: 'Сведения о виде назначенного наказания',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/type/name': {
    name: 'Тип лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentAmount': {
    name: 'Сумма размера наказаний',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentAmountMeasure': {
    name: 'Единица измерений размера наказаний',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/organizationName': {
    name: 'Наименование лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/ogrn': {
    name: 'ОГРН лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/subjectType/title': {
    name: 'Тип лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/subjectType/name': {
    name: 'Должностное лицо',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentNote': {
    name: 'Комментарий',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/country/title': {
    name: 'Государство, в котором указанное юридическое лицо зарегистрировано',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/inn': {
    name: 'ИНН лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/snils': {
    name: 'Снилс лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/position': {
    name: 'Должность лица, привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/fullName': {
    name: 'ФИО лица привлеченного к ответственности',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/structuresNPA/{id}/value': {
    name:
      'Структурная единица нормативных правовых актов, содержащая информацию о мерах ответственности контролируемых лиц',
  },
  '/organization/{id}/resultDecisions/{id}/responsibleEntities/{id}/punishmentUins': {
    name: 'УИН',
  },
  '/organization/{id}/resultDecisions/{id}/links/{id}/erpId': {
    name: 'Ссылка на другой паспорт КНМ или ПМ',
  },
  '/organization/{id}/resultDecisions/{id}/injunction/dateResolved': {
    name: 'Срок исполнения решения',
  },
  '/organization/{id}/resultDecisions/{id}/injunction/note': {
    name:
      'Информация о проведении мероприятий по предотвращению причинения вреда (ущерба) охраняемым законом ценностям',
  },
  '/resultOfInspection': {
    name: 'Результат профилактического мероприятия',
  },
  '/isViolations': {
    name: 'Выявлены нарушения обязательных требований',
  },
  // '/judgments/{id}/dateJudgment': {
  //   name: 'Дата судебного решения',
  // },
  // '/judgments/{id}/numberJudgment': {
  //   name: 'Номер судебного решения',
  // },
  // '/judgments/{id}/judgmentAction': {
  //   name: 'Действие судебного решения',
  // },
  // '/judgments/{id}/kindJudgment/name': {
  //   name: 'Вид судебного решения',
  // },
  // '/judgments/{id}/attachment/{id}/fileName': {
  //   name: 'Файл судебного решения',
  // },
  // '/judgments/{id}/court/rfRegion': {
  //   name: 'Субъект Российской Федерации',
  // },
  // '/judgments/{id}/court/title': {
  //   name: 'Наименование суда',
  // },
  // '/judgments/{id}/court/courtType': {
  //   name: 'Уровень суда',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationActsAndDecisions/{id}/cancellationInformation/name': {
  //   name: 'Сведения о решениях в рамках решения, которые отменены или изменены',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationActsAndDecisions/{id}/explanation': {
  //   name: 'Сведения о решениях в рамках решения, которые отменены или изменены - Пояснение',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/amountOfPunishment': {
  //   name: 'Размер наказания контролируемого лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/prosecutionType/name': {
  //   name: 'Вид ответственности контролируемого лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/punishmentType/name': {
  //   name: 'Вид наказания контролируемого лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/punishmentIndex/name': {
  //   name: 'Показатель наказания контролируемого лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/explanation': {
  //   name: 'Дополнительная информация о наказании контролируемого лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/officialPersonFio': {
  //   name: 'ФИО должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/officialPersonJobTitle': {
  //   name: 'Должность должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/amountOfPunishment': {
  //   name: 'Размер наказания должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/prosecutionType/name': {
  //   name: 'Вид ответственности должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/punishmentType/name': {
  //   name: 'Вид наказания должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/punishmentIndex/name': {
  //   name: 'Показатель наказания должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/explanation': {
  //   name: 'Дополнительная информация о наказании должностного лица',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/cancellationInformation/name': {
  //   name: 'Виды информации об отмене Акта КНМ',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/explanation': {
  //   name: 'Пояснение об отмене Акта КНМ',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/cancellationInformation/name': {
  //   name: 'Виды информации об отмене Решения КНМ',
  // },
  // '/judgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/explanation': {
  //   name: 'Пояснение об отмене Решения КНМ',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/cancellationInformation/name': {
  //   name: 'Виды информации об отмене Судебного решения для контролируемого лица',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOrganizations/explanation': {
  //   name: 'Пояснение об отмене Судебного решения для контролируемого лица',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/cancellationInformation/name': {
  //   name: 'Виды информации об отмене Судебного решения для должностного лица',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/judgmentAgainstOfficialPerson/{id}/explanation': {
  //   name: 'Пояснение об отмене Судебного решения для должностного лица',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/newCancellationInformation/name': {
  //   name: 'Виды информации об отмене Судебного решения для Акта КНМ',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationActs/{id}/newExplanation': {
  //   name: 'Пояснение об отмене Судебного решения для Акта КНМ',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/newCancellationInformation/name': {
  //   name: 'Виды информации об отмене Судебного решения для Решения КНМ',
  // },
  // '/judgments/{id}/canceledJudgments/{id}/judgmentSubjectData/{id}/cancellationDecisions/{id}/newExplanation': {
  //   name: 'Пояснение об отмене Судебного решения для Решения КНМ',
  // },
  '/subject/ogrn': {
    name: 'Основной государственный регистрационный номер (ОГРН)',
  },
  '/subject/inn': {
    name: 'Идентификационный номер налогоплательщика (ИНН)',
  },
  '/subject/organizationName': {
    name: 'Наименование проверяемого лица',
  },
  '/subject/organizationName/fio': {
    name: 'Фамилия, имя, отчество (при наличии)',
  },
  '/subject/isSonko': {
    name: 'Наличие контролируемого лица в реестре СОНКО',
  },
  '/subject/nkoForeignAgentsRegistryNumber': {
    name: 'Регистрационный номер в реестре НКО-иноагентов',
  },
  '/subject/nkoForeignAgentsRegistryInclusionDate': {
    name: 'Дата включения в реестр НКО иноагентов',
  },
  '/subject/nkoForeignAgentsRegistryExclusionDate': {
    name: 'Дата исключения в реестр НКО иноагентов',
  },
  '/subject/locationAddress': {
    name: 'Адрес места нахождения',
  },
  '/subject/workAddress': {
    name: 'Место нахождения (осуществления деятельности) контролируемого лица',
  },
  '/subject/factualAddress': {
    name: 'Место фактического осуществления деятельности',
  },
  '/subject/snils': {
    name: 'Страховой номер индивидуального лицевого счета (СНИЛС)',
  },
  '/subject/document': {
    name: 'Сведения о документе, удостоверяющем личность',
  },
  '/subject/mspCode': {
    name: 'Категория субъекта МСП',
  },
  '/subject/country': {
    name: 'Государство, в котором указанное юридическое лицо зарегистрировано',
  },
  '/subject/{id}': {
    name: 'ОКВЭД',
  },
  '/subject/okveds/{id}/name': {
    name: 'Наименование ОКВЭД',
  },
  '/subject/okveds/{id}/code': {
    name: 'Номер ОКВЭД',
  },
  '/subject/isPresentInItRegistry': {
    name: 'Наличие в реестре аккредитованных IT-организаций',
  },
  '/subject/subjectType/title': {
    name: 'Тип контролируемого лица',
  },
  '/subject/itAccreditationResponse/registryNumber': {
    name: 'Регистрационный номер',
  },
  '/subject/itAccreditationResponse/dateDecisionAccreditation': {
    name: 'Дата включения',
  },
  '/subject/itAccreditationResponse/organizationStatus': {
    name: 'Статус',
  },
  '/subject/rafpNza': {
    name: 'Номер записи об аккредитации в РАФП',
  },
  '/subject/kpp': {
    name: 'Код причины постановки на учет (КПП)',
  },
  '/subjectNotifications/{id}/date': {
    name: 'Дата уведомления контролируемого лица',
  },
  '/subjectNotifications/{id}/comment': {
    name: 'Примечание к уведомлению контролируемого лица',
  },
};
